import {isDownloadOptions} from '@github-ui/swp-core/schemas/contentful/contentTypes/downloadOptions'

import {useGenericCtaAction} from '../../../../brand/components/GenericCtaAction/use-generic-cta-action'
import type {ResolvedGenericCta} from '../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: ResolvedGenericCta
  location: string
}

export function CtaButtons(props: Props) {
  const {contentfulContent, location} = props

  const {primary, secondary} = contentfulContent
  const primaryAction = useGenericCtaAction(primary, {
    analytics: {tag: 'button', context: 'CTAs', location},
    className: `CtaForm-primaryAction ${location === 'hero' ? 'js-hero-action' : ''}`,
    variant: 'primary',
  })
  const secondaryAction = useGenericCtaAction(secondary, {
    analytics: {tag: 'button', context: 'CTAs', location},
    className: `CtaForm-secondaryAction ${location === 'hero' ? 'js-hero-action' : ''}`,
  })

  return (
    <>
      {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
      <div className={`CtaForm${location !== 'hero' ? ' CTAForm-footer' : ''}`}>
        {isDownloadOptions(primary) ? (
          /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
          <div className={`CtaForm-primaryAction ${location === 'hero' ? 'js-hero-action' : ''}`}>
            {primaryAction.action}
          </div>
        ) : (
          primaryAction.action
        )}

        {isDownloadOptions(secondary) ? (
          /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
          <div className={`CtaForm-secondaryAction ${location === 'hero' ? 'js-hero-action' : ''}`}>
            {secondaryAction.action}
          </div>
        ) : (
          secondaryAction.action
        )}
      </div>

      {primaryAction.feedback}
      {secondaryAction.feedback}
    </>
  )
}
